import React from 'react';
import { painPoints } from '../data/painPoints';
import { OFFER_ANCHOR } from './constants';
export function PainSection() {
  return <section className="border-y border-brand-line bg-brand-cream px-4 py-5" data-id="element-82" data-mp="38xesl6ri6bos">
      <div className="mx-auto max-w-4xl" data-id="element-83" data-mp="2ux41c2ma6v33">
        <h2 className="mb-2 text-center font-display text-lg font-extrabold uppercase leading-tight sm:text-3xl" data-id="element-84" data-mp="2v08evqlmz36f">
          Cela vous semble familier ?
        </h2>
        <div className="mx-auto mb-3 max-w-3xl space-y-1 text-center text-[13px] font-medium leading-snug text-brand-muted sm:text-base" data-id="element-85" data-mp="2l7kgwsix6t64">
          <p data-id="element-86" data-mp="2q0vrn4quru3b">
            La domotique vous intéresse. Vous aimeriez comprendre comment rendre une maison
            réellement intelligente. Vous avez peut-être déjà regardé des vidéos, lu des guides ou
            acheté quelques appareils connectés... Mais au moment de tout assembler, les questions
            commencent.
          </p>
          <p data-id="element-87" data-mp="278ulrifnv3ke">
            Quel système choisir ? Quels appareils sont compatibles ? Faut-il une passerelle ? Wi-Fi,
            Zigbee, Thread ou Matter ? Par où commencer ? Et surtout... Comment passer de quelques
            appareils connectés à une véritable installation domotique organisée et fonctionnelle ?
          </p>
          <p className="font-semibold text-brand-ink" data-id="element-88" data-mp="5far9imqi31n">
            Si vous partez de zéro, vous avez probablement déjà rencontré au moins l’un de ces
            problèmes.
          </p>
        </div>

        <div className="grid gap-2 sm:grid-cols-2" data-id="element-89" data-mp="38wsv7ezdypws">
          {painPoints.map(point => <a key={point.title} href={OFFER_ANCHOR} className="rounded-xl border border-brand-line bg-white p-3 shadow-sm transition-colors duration-150 ease-out hover:border-brand-orange" data-id="element-90" data-mp="33z16etu1fjwt">
              <h3 className="mb-1 font-display text-[13px] font-bold leading-tight text-brand-ink sm:text-base" data-id="element-91" data-mp="2q5ry6whtt4fv">
                {point.title}
              </h3>
              {point.lines.map(line => <p key={line} className="mt-0.5 text-xs font-medium leading-snug text-brand-muted sm:text-sm" data-id="element-92" data-mp="p4byvbnzenq9">
                  {line}
                </p>)}
            </a>)}
        </div>
      </div>
    </section>;
}